import { TableViewCustomModel } from '../../tva-custom/common/model/table-view-custom-model';

export class TableViewSessionModel {
  public readonly pivotMode: boolean;
  public readonly columnState: string;
  public readonly filterModel: string;
  public readonly tableViewCustomModel: TableViewCustomModel;

  /**
   * @param pivotMode         - If RootComponent is using a PivotTable like reportingComponent this contains true/false (on/off). Else false
   * @param columnState       - The current columnState (gridApi.getColumnState())
   * @param filterModel       - The filterModel (gridOptions.api.getFilterModel())
   * @param tableViewCustomModel    - If rootComponent embedded the tableViewAdministration-Component- this contains the sel. customized tableView
   */
  public constructor(
    pivotMode: boolean,
    columnState: string,
    filterModel: string,
    tableViewCustomModel: TableViewCustomModel,
  ) {
    this.pivotMode = pivotMode;
    this.columnState = columnState;
    this.filterModel = filterModel;
    this.tableViewCustomModel = tableViewCustomModel;
  }
}
